import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { Testids } from '@mono/ui-selectors';
import { VehicleRelationshipsSection } from '../../../Delivery/Registries/VehicleRelationshipsSection';
/**
 * Recorded holdings for one vehicle, opened from "Holders we track › Record holding".
 * Reuses the existing relationship list + editor, so adding, editing and archiving a
 * holding work exactly as before; only the page block is gone (mockup: no editor on the page).
 */ export function HoldingsDialog({ vehicleId, vehicleName, open, onOpenChange }) {
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: open,
        onOpenChange: onOpenChange,
        title: `Holdings on ${vehicleName}`,
        description: "Who holds this vehicle, for what scope and period, and how we know.",
        size: "xl",
        scrollBody: true,
        testId: Testids.registryVehicle.holdingsDialog,
        children: /*#__PURE__*/ _jsx(VehicleRelationshipsSection, {
            vehicleId: vehicleId
        })
    });
}
